<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">{{!selectCampoAdicionalCategoria ? 'Agregar' : 'Editar'}} Campo Adicional de Categoria</label>
      </header>

      <form [formGroup]="formCampoAdicionalCategoria" (ngSubmit)="onOperarCampoAdicionalCategoria()">
        <!-- Campo adicional -->
        <div class="form-group">
          <label class="small text-secondary" for="nit">Campo Adicional</label>
          <select class="form-control form-control-sm" id="campo_adicional_id" formControlName="campo_adicional_id">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" *ngFor="let option of campoAdicional; let i = index" value="{{option?.campo_adicional_id}}"
              [selected]="false">
              {{option?.descripcion}}
            </option>
          </select>
        </div>
        <!-- Categoria -->
        <div class="form-group">
          <label class="small text-secondary" for="nit">Categoria</label>
          <mat-select class="form-control form-control-sm" id="categoria" placeholder="Seleccione"
            formControlName="categoria" multiple disableOptionCentering>
            <mat-option #allSelected (click)="selectAllCategories()" [value]="0">
              TODAS LAS CATEGORIAS
            </mat-option>
            <mat-option *ngFor="let option of categoria; let i = index" id="i" (click)="allCategories(allSelected.viewValue)" [value]="option?.categoria_id">
              {{option?.descripcion}}
            </mat-option>
          </mat-select>
        </div>
        <!--<div class="form-group">
          <label class="small text-secondary" for="nit">Tipo de prestador</label>
          <mat-checkbox color="primary" (change)="commercialResult( $event.checked, 'aplica_Comerciante' )" formControlName="aplica_Comerciante"><label class="small text-secondary category-check" for="nit">Se muestra para Comerciante</label></mat-checkbox>
          <mat-checkbox color="primary" (change)="commercialResult( $event.checked, 'aplica_No_Comerciante' )" formControlName="aplica_No_Comerciante"><label class="small text-secondary category-check" for="nit">Se muestra para No comerciante</label></mat-checkbox>
        </div>-->
        <!-- Estado -->
        <div class="form-group">
          <label class="small text-secondary" for="nit">Estado</label>
          <select class="form-control form-control-sm" id="activo" formControlName="activo"
            [attr.disabled]="!selectCampoAdicionalCategoria ? '' : null">
            <option class="" [ngValue]="null" selected="true">
              Seleccione
            </option>
            <option class="" [ngValue]="1" [selected]="false">
              Activo
            </option>
            <option class="" [ngValue]="0" [selected]="false">
              Inactivo
            </option>
          </select>
        </div>
        <!-- Botonera -->
        <div class="form-row mt-5">
          <button type="button" class="btn btn-outline-primary border-0 m-auto"
            (click)="limpiarCampoAdicionalCategoria()">Limpiar</button>
          <button class="btn btn-primary m-auto " [disabled]="!formCampoAdicionalCategoria.valid" type="submit">{{!selectCampoAdicionalCategoria
            ? 'Agregar' : 'Editar'}}</button>
        </div>
      </form>
    </section>

    <section class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <label class="h5">Listado Campos Adicionales de Categorias</label>
        </div>
        <p>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </p>
      </div>

      <div id="filtros" [ngbCollapse]="isCollapsed">
        <div class="card mb-3">
          <div class="card-body">
            <form [formGroup]="filtro" (submit)="filtrar()">
              <div class="row">
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Campo Adicional</label>
                  <select class="form-control form-control-sm" id="campo_adicional_id"
                    formControlName="campo_adicional_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of campoAdicional; let i = index"
                      value="{{option?.campo_adicional_id}}" [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Categoria</label>
                  <select class="form-control form-control-sm" id="categoria_id" formControlName="categoria_id">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" *ngFor="let option of categoria; let i = index" value="{{option?.categoria_id}}"
                      [selected]="false">
                      {{option?.descripcion}}
                    </option>
                  </select>
                </div>
                <div class="col-2 form-group">
                  <label class="small text-secondary" for="nit">Estado</label>
                  <select class="form-control form-control-sm" id="activo" formControlName="activo">
                    <option class="" [ngValue]="null" selected="true">
                      Seleccione
                    </option>
                    <option class="" [ngValue]="1" [selected]="false">
                      Activo
                    </option>
                    <option class="" [ngValue]="0" [selected]="false">
                      Inactivo
                    </option>
                  </select>
                </div>
                <div class="d-flex flex-row">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto"
                    (click)="limpiar()">Limpiar</button>
                  <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">Filtrar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <app-tablas [page]="paginaActual" [headers]="headerCampoAdicionalCategoria"
          [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)" class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.campo_adicional_id}}</td>
            <td>{{item.descripcion_campo_adicional}}</td>
            <td>{{item.categoria_id}}</td>
            <td>{{item.descripcion_categoria}}</td>
            <td>{{item.activo ? 'Activo' : 'Inactivo'}}</td>
            <td class="d-flex flex-row">
              <img src="../../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
                (click)="onCargarCampoAdicionalCategoria(item)">
              <img src="../../../../../../../../assets/icons/delete.png" class="pointer" alt="" height="25"
                (click)="onEliminarCampoAdicionalCategoria(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </section>
  </article>
</main>
